import { set } from './tempStorage';
import { NavType } from '../constants';
export const navPlaceholderLocalStorageKey = 'NAVIGATION_PLACEHOLDER_VARIANT';
const setNavPlaceholderType = () => {
  set(navPlaceholderLocalStorageKey, NavType.VERTICAL);
};
export default setNavPlaceholderType;